import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input',
  standalone: false
})
export class SelectInputContentOnFocusDirective {

  constructor() { }

  @HostListener('focus', ['$event']) public focus(e) {
    e.target.select();
  }

}
